import {type VehicleV2ResponseBody} from '@online-offer/shared';

import {Nullish} from 'shared/web';

export type TechnicalParamsDataBundle = {
  dimensions: {
    width: string | undefined;
    height: string | undefined;
    length: string | undefined;
  };
  details: {
    trunkSpace: string | undefined;
    operatingWeight: string | undefined;
    weight: string | undefined;
    maximalLoadCapacity: string | undefined;
  };
};

export const getDataForTechnicalParameters = (
  vehicle: VehicleV2ResponseBody | Nullish
): TechnicalParamsDataBundle => ({
  dimensions: {
    width: vehicle?.dimensions?.width ? String(vehicle.dimensions.width) : undefined,
    height: vehicle?.dimensions?.height ? String(vehicle.dimensions.height) : undefined,
    length: vehicle?.dimensions?.length ? String(vehicle.dimensions.length) : undefined,
  },
  details: {
    trunkSpace: vehicle?.trunkSpace ? String(vehicle.trunkSpace) : undefined,
    operatingWeight: vehicle?.operatingWeight ? String(vehicle.operatingWeight) : undefined,
    weight: vehicle?.weight ? String(vehicle.weight) : undefined,
    maximalLoadCapacity: vehicle?.maximalLoadCapacity
      ? String(vehicle.maximalLoadCapacity)
      : undefined,
  },
});
